import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StrideSchoolReportData } from '@mira-avant/mtlibs';
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
	selector: 'app-stride-school-report-summary',
	imports: [CommonModule, NzButtonModule, NzIconModule],
	standalone: true,
	templateUrl: './stride-school-report-summary.html',
	styleUrl: './stride-school-report-summary.scss',
})
export class StrideSchoolReportSummary {
	@Input('report') public report:StrideSchoolReportData | undefined;
}
